export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/summer_sale.fde28bb7.gif","height":600,"width":600,"blurWidth":0,"blurHeight":0};